const CACHE_KEY = "homevilas.elivaas.rates";
const MAX_ITEMS = 120;

const safeParse = (raw) => {
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
};

export const cacheElivaasRates = (payload) => {
  if (!payload || !Array.isArray(payload.list)) return;
  const snapshot = {
    updatedAt: Date.now(),
    items: payload.list
      .filter((item) => item?.id)
      .map((item) => {
        const quotes = Array.isArray(item.quotes) ? item.quotes : [];
        const propertySnapshot =
          quotes.find((quote) => quote?.homevilasQuote?.property_snapshot)?.homevilasQuote
            ?.property_snapshot || null;
        return {
          id: String(item.id),
          propertyName: item.propertyName || propertySnapshot?.title || "",
          propertySnapshot,
          quotes,
        };
      })
      .slice(0, MAX_ITEMS),
  };
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(snapshot));
  } catch (_) {
    // ignore storage errors
  }
};

export const getCachedElivaasProperty = (propertyId) => {
  if (!propertyId) return null;
  const cached = safeParse(sessionStorage.getItem(CACHE_KEY));
  if (!cached || !Array.isArray(cached.items)) return null;
  return cached.items.find((item) => String(item.id) === String(propertyId)) || null;
};
